import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { topBarHeight } from 'theme/uiConfig';
import { connect } from 'react-redux';
import { fade } from '@material-ui/core/styles/colorManipulator';
import HamburgerButton from 'components/HamburgerButton/HamburgerButton';
import { isAdmin } from 'utils/state';
import { TEMP_COMP_PREFIX } from 'config';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	toolbar: {
		minHeight: topBarHeight
	},
	title: {
		fontSize: 18,
		fontWeight: 'normal',
		fontFamily: '"Open Sans Xara"',
		width: 260
	},
	hamburgerButton: {
		'& + h1': {
			marginLeft: 30
		}
	},
	link: {
		color: theme.palette.common.white,
		backgroundColor: theme.palette.colors.beta,
		'&:disabled': {
			backgroundColor: fade(theme.palette.colors.beta, 0.3)
		},
		'&:hover': {
			backgroundColor: theme.palette.colors.eta,
		}
	},
	toolbarGutters: {
		paddingLeft: 30,
		paddingRight: 30
	},
	trialButton: {
		marginRight: 15,
		fontSize: 16,
		backgroundColor: theme.palette.colors.purple,
		'&:hover': {
			backgroundColor: theme.palette.colors.purpleHover,
			boxShadow: 'none'
		},
		minWidth: 50
	},
	closeIcon: {
		color: '#F7F7F7',
		'&:hover':{
			color: '#BAE6FF',
		},
	},
	buttonsContainer: {
		marginLeft: 'auto',
	},
	disabled: {}
});

@withStyles(styles)
class TopBar extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selected: -1
		};
	}

	renderUpgradeButton() {
		const { classes, company: { hasTrial, trialDays, id }, isAdmin } = this.props;

		if (!hasTrial || !isAdmin) {
			return null;
		}

		return (<Button
			data-tid="button-top-bar-subscription"
			href={`#${id}/subscription`}
			variant='contained'
			className={classes.trialButton}>
			{trialDays} {localize(trialDays === 1 ? 'top-bar-upgrade-button-day' : 'top-bar-upgrade-button-days')}
		</Button>);
	}

	render() {
		const { classes, navOpen, navToggle, company, onBoardingEnabled } = this.props;
		const shouldRenderButtons = !onBoardingEnabled;
		const shouldRenderTeamName = !company.displayName.includes(TEMP_COMP_PREFIX);

		return (
			<AppBar className={classes.root}>
				<Toolbar classes={{
					root: classes.toolbar,
					gutters: classes.toolbarGutters
				}}>
					{shouldRenderButtons && <HamburgerButton
						open={navOpen}
						onChange={!onBoardingEnabled ? navToggle : undefined}
						classes={{ root: classes.hamburgerButton }}
					/>}
					{shouldRenderTeamName && <Typography variant="h1" color="inherit" noWrap className={classes.title}>
						{company.displayName}
					</Typography>}
					<div className={classes.buttonsContainer}>
						{shouldRenderButtons && this.renderUpgradeButton()}
					</div>
				</Toolbar>
			</AppBar>
		);
	}
}

TopBar.propTypes = {
	classes: PropTypes.object,
	navToggle: PropTypes.func.isRequired,
	navOpen: PropTypes.bool,
	workspace: PropTypes.object,
	company: PropTypes.object,
	onBoardingEnabled: PropTypes.bool,
	isAdmin: PropTypes.bool
};

TopBar.defaultProps = {
	company: {},
	workspace: {},
	navBar: true,
	onBoardingEnabled: false,
	isAdmin: false
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId],
	workspace: state.workspaces.rawDataById[state.workspaces.selectedId],
	isAdmin: isAdmin(state)
});

export default connect(
	mapStateToProps,
	undefined
)(TopBar);


// WEBPACK FOOTER //
// ./src/components/TopBar/TopBar.js